export default __webpack_public_path__ + "static/media/eye.1bc8e9e3.svg";